/* global Sys, Core */
Sys.ns("Core");

/**
 * The Play For Real Promo module.
 *
 * The module handling the play for real promo (asking the player if he/she wants to play for real money).
 *
 * @class Core.PlayForRealPromo
 * @extends Core.Module
 */
Core.PlayForRealPromo = {

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.PlayForRealPromo.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    getStateChanges: function() {
        return {
            idle: {
                waitEvents: [
                    "notify:playForRealPromo:completed"
                ]
            }
        };
    },

    /**
     * @protected
     * @inheritdoc
     */
    getDefaultMVCClasses: function() {
        return {
            model: Core.PlayForRealPromoModel,
            view: Core.View,
            controller: Core.PlayForRealPromoController
        };
    }
};

Core.PlayForRealPromo = Sys.extend(Core.Module, Core.PlayForRealPromo, "Core.PlayForRealPromo");
